/**
 * The name of a person (Employee, User): `'last-first'` (the default) gives "Nachname, Vorname", `'natural'`
 * gives "Vorname Nachname" (the picker gimmick's big name, feature plan 0072).
 *
 * A tenant may keep only first names, and a last name is not forced
 * (ticket AaDUz8N0cLqoz6BVG58uCQ), so only the non-blank parts are joined:
 * a missing part takes its separator with it. Both parts empty gives
 * `''`, which callers can treat as "no name".
 */
export type PersonNameOrder = 'last-first' | 'natural';

export function formatPersonName(lastName: string, firstName: string, order: PersonNameOrder = 'last-first'): string {
    const parts = order === 'natural' ? [firstName, lastName] : [lastName, firstName];
    return parts
        .map(part => (part ?? '').trim())
        .filter(part => part !== '')
        .join(order === 'natural' ? ' ' : ', ');
}
